import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { useUser } from "@/context/UserContext";
import styles from "./ExploreDropdown.module.css";

export default function ExploreDropdown() {
  const router = useRouter();
  const { user } = useUser();
  const [open, setOpen] = useState(false);

  const canSeeCandidates =
    !user ||
    (user &&
      (user.role === "hr" ||
        user.userType === "hr" ||
        user.role === "admin" ||
        user.userType === "hr-admin"));

  const isActive = (href) => router.pathname === href;

  const toggleDropdown = (e) => {
    e.preventDefault();
    setOpen(!open);
  };

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <li
      className={`has-dropdown ${open ? "open" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        href="#"
        onClick={toggleDropdown}
        className={`d-flex align-items-center justify-content-between ${isActive("/company-enquiry") ||
            isActive("/list-instructor") ||
            isActive("/candidates")
            ? "active"
            : ""
          }`}
        style={{ gap: "6px" }}
      >
        <span>👥 Members</span>
        <i
          className={`fas fa-chevron-${open ? "up" : "down"}`}
          style={{ fontSize: "0.8rem" }}
        ></i>
      </Link>

      <ul className="submenu" style={{ display: open ? "block" : "none" }}>
        <li>
          <Link
            href="/company-enquiry"
            className={isActive("/company-enquiry") ? "active" : ""}
          >
            💬 Companies
          </Link>
        </li>

        <li>
          <Link
            href="/list-instructor"
            className={isActive("/list-instructor") ? "active" : ""}
          >
            🧑‍🏫 Instructors
          </Link>
        </li>

        {canSeeCandidates && (
          <li>
            <Link
              href="/candidates"
              className={isActive("/candidates") ? "active" : ""}
            >
              🙋‍♂️ Candidates
            </Link>
          </li>
        )}
      </ul>
    </li>
  );
}
